import * as React from "react";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PasswordStrengthMeter from "./PasswordStrengthMeter";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles({
  row: {
    display: "flex",
    justifyContent: "space-between",
  },
  gapBottom: {
    marginBottom: "8px",
  },
  error: {
    color: "red",
    fontStyle: "italic",
  },
  errorIcon: {
    position: "absolute",
    right: "5px",
    top: "5px",
    color: "red",
  },
  textField: {
    "& div input": {
      padding: "7px 12px 10px",
    },
    width: "100%",
  },
  relative: {
    position: "relative",
  },
  strngthMeter: {
    position: "absolute",
    top: "10px",
    width: "100px",
    right: "32px",
  },
  errorVisibleButton: {
    position: "absolute",
    right: "5px",
    top: "2px",
    padding: "3px",
  },
  visibleButton: {
    position: "absolute",
    right: "27px",
    top: "2px",
    padding: "3px",
  },
  passwordStrengthText: {
    position: "absolute",
    top: "37px",
  },
});

const TextInput = (props) => {
  const {
    value,
    type,
    enablePasswordStrength,
    enableVisibleIcon,
    required,
    placeHolder,
    className,
    id,
    ...rest
  } = props;
  const inputId = id || props.name || "filled-basic";
  const [visible, setVisible] = React.useState("");
  const [passwordStrengthText, setPasswordStrengthText] = React.useState({});
  const handleShowPassword = () => {
    if (visible) {
      setVisible("");
    } else {
      setVisible("text");
    }
  };
  const handlePasswordSterngthText = (text) => {
    setPasswordStrengthText(text);
  };
  let classes = useStyles();
  return (
    <>
      <div>
        <div className={classes.row}>
          {props.level && (
            <label htmlFor={inputId} className={classes.gapBottom}>{props.level}</label>
          )}
        </div>
        <div className={classes.relative}>
          <TextField
            error={props.error || false}
            id={inputId}
            variant="filled"
            type={visible || props.type || "text"}
            value={props.value || ""}
            name={props.name || ""}
            className={`${classes.textField} ${className}`}
            onChange={props.onChange && props.onChange}
            onKeyPress={props.onKeyPress && props.onKeyPress}
            required={!!required}
            placeholder={placeHolder||""}
            {...rest}
            inputProps={{
              ...rest.inputProps,
              'aria-invalid': props.error || false,
              'aria-describedby': props.textError ? `${inputId}-error` : (rest.inputProps?.['aria-describedby'] || undefined),
            }}

          />
          {props.error && <ErrorOutlineIcon className={classes.errorIcon} />}
          {!!enableVisibleIcon &&
            (!!visible ? (
              <IconButton
                className={`${
                  props.error
                    ? classes.visibleButton
                    : classes.errorVisibleButton
                }`}
                title="Show password"
                onClick={handleShowPassword}
              >
                <VisibilityIcon color="primary" />
              </IconButton>
            ) : (
              <IconButton
                className={`${
                  props.error
                    ? classes.visibleButton
                    : classes.errorVisibleButton
                }`}
                title="Hide password"
                onClick={handleShowPassword}
              >
                <VisibilityOffIcon color="primary" />
              </IconButton>
            ))}
          {!!enablePasswordStrength && props.value && (
            <div className={classes.strngthMeter}>
              <PasswordStrengthMeter
                password={props.value}
                handlePasswordSterngthText={handlePasswordSterngthText}
              />
            </div>
          )}
          {passwordStrengthText && passwordStrengthText.text && props.value && (
            <div
              className={classes.passwordStrengthText}
              style={{ color: `${passwordStrengthText.color}` }}
            >
              {passwordStrengthText.text}
            </div>
          )}
          {props.textError && (
            <div id={`${inputId}-error`} className={classes.error} role="alert">{props.textError}</div>
          )}
        </div>
      </div>
    </>
  );
};
export default TextInput;
